import { Howl } from 'howler'

export default class Player {
  private sound?: Howl
  private playing: boolean

  constructor() {
    this.playing = false
  }

  play(src: string, duration: number) {
    if (this.playing) {
      return
    }

    this.playing = true
    this.sound?.unload()
    this.sound = new Howl({ src, loop: true })
    this.sound.play()

    setTimeout(() => {
      this.stop()
      this.playing = false
    }, duration)
  }

  stop() {
    this.sound?.stop()
    this.sound?.unload()
  }

  setMute(mute: boolean) {
    this.sound?.mute(mute)
  }
}
